<template>
    <div class="head">
        <div class="my-contact flex-aic">
            <div class="mail item">
                <div class="icon">
                    <img src="../img/mail.png" alt="">
                </div>
                <p>{{ us_mail }}</p>
            </div>
            <div class="phone item">
                <div class="icon">
                    <img src="../img/phone.png" alt="">
                </div>
                <p>{{ us_phone }}</p>
            </div>
        </div>
        <div class="my-head">
            <div class="container flex-aic">
                <div class="logo">
                    <h2 class="mingzi">{{ company_name }}</h2>
                </div>
                <div class="tab flex-aic">
                    <div class="item" :class="{ active: isActive('/index') }">
                        <router-link to="/index"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s;">首页</router-link>
                    </div>
                    <div class="item" :class="{ active: isActive('/about') }">
                        <router-link to="/about"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s">关于我们</router-link>
                    </div>
                    <div class="item" :class="{ active: isActive('/product') }">
                        <router-link to="/product"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">产品与服务</router-link>
                    </div>
                    <div class="item" :class="{ active: isActive('/news') }">
                        <router-link to="/news"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">新闻中心</router-link>
                    </div>
                    <div class="item" :class="{ active: isActive('/contact') }">
                        <router-link to="/contact"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">联系我们</router-link>
                    </div>
                    <div class="search flex-aic">
                        <input type="text" v-model="search" placeholder="请输入搜索内容">
                        <div class="img flex-aic" @click="handleSearch(search)">
                            <img src="../img/search.png" alt="">
                        </div>
                    </div>
                     <!-- 这里将显示搜索结果 -->
                    <!-- <div id="searchResults" v-if="showResults">
                       
                        <div id="searchResults-box" v-for="item in searchResults" :key="item.id"
                            @click="contentSearch(item.type, item.id)">
                            {{ item.title }}
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { getSearch } from "@/api/HeadSearch";
// import { getnewsinfoList } from "@/api/news";
// import { getIndustryListInfo } from "@/api/product";
import { addressList } from "@/api/index";
export default {
    name: 'HeadCommon',
    data() {
        return {
            search: '',
            showResults: false,
            searchResults: [],
            us_phone: '',
            us_mail: '',
            company_name: '',
        }
    },
    created(){
            this.addressList()
        },
    methods: {
        isActive(route) {
            // 路由调转的路径三等于调用传递过来的路径的时候，就增加active的类的样式
            return this.$route.path === route;
        },
        
        async addressList() {
            const { data } = await addressList()
            console.log(data,456666);
            this.company_name = data.company_name
            this.us_phone = data.us_phone
            this.us_mail = data.us_mail
        },
        async handleSearch(search) {
            // console.log(search);
            const { data } = await getSearch(search)
            if(Array.isArray(data) && data.length === 0){
                console.log(Array.isArray(data),444);
                  // 如果data为空，则不进行跳转
                  this.search = ''
            }else{
                this.$router.push({ name: 'searchResults', params: { query: search } });
            }
            
            
        },
        // async contentSearch(type, id) {
        //     if (type === 1) {
        //         const res = await getnewsinfoList(id)
        //         console.log(id,"搜索");
        //         console.log(res);
        //         this.$store.state.pageId = id
        //         const routePath = `/newsinfo/${id}`;
        //         this.$router.push(routePath);
        //     }
        //     if (type === 2) {
        //         const res = await getIndustryListInfo(id)
        //         console.log(res,15698);
        //         this.$store.state.pageId = id
        //         const routePaths = '/listdetails'
        //         this.$router.push(routePaths)
        //     }
        // }
    }
}
</script>
  
<style scoped>
@import '../style/common.css';
@import '../style/basic.css'
</style>